module.exports = "<app-form (submitEvent)=\"price.getPrices()\"></app-form>\n<app-price #price></app-price>"